"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));
var _styles = require("./styles");
var _Dropdown = _interopRequireDefault(require("../Dropdown"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _messages = _interopRequireDefault(require("./messages"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } //styled-components
//messages
var SelectComponent = function SelectComponent(props) {
  var _selectedOption$name, _selectedOption$name2, _selectedOption$name3;
  var formatMessage = props.intl.formatMessage,
    disabled = props.disabled,
    feedbackText = props.feedbackText,
    label = props.label,
    style = props.style,
    display = props.display,
    width = props.width,
    allowClear = props.allowClear,
    placeholder = props.placeholder,
    showSearch = props.showSearch,
    options = props.options,
    notFoundContent = props.notFoundContent,
    selectedValue = props.selectedValue,
    defaultValue = props.defaultValue,
    field = props.field,
    form = props.form,
    _props$inputId = props.inputId,
    inputId = _props$inputId === void 0 ? (0, _uniqueId["default"])('select-') : _props$inputId,
    loading = props.loading;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    selectorOpened = _useState2[0],
    setSelectorOpened = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = _slicedToArray(_useState3, 2),
    userInput = _useState4[0],
    setUserInput = _useState4[1];
  var wrapperRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    checkIfAtBottom({
      target: wrapperRef.current
    });
  }, [selectorOpened, userInput, options]);
  var toggleSelector = function toggleSelector(e) {
    if (e !== null && e !== void 0 && e.preventDefault) e.preventDefault();
    if (disabled) return;
    setSelectorOpened(!selectorOpened);
  };
  var onChange = function onChange(value) {
    var onChange = props.onChange;
    if (disabled) return;
    if (form && field) form.$(field).sync(value);
    if (onChange) onChange(value);
    setUserInput('');
    toggleSelector();
  };
  var updateUserInput = function updateUserInput(e) {
    var onSearch = props.onSearch;
    setUserInput(e.target.value);
    if (onSearch) onSearch(userInput);
    if (!selectorOpened) toggleSelector();
  };
  var handleInputKeydown = function handleInputKeydown(event) {
    // enter key pressed
    if (event.keyCode === 13 && options.length) {
      var firstAvailableOption = options[0].id;
      onChange(firstAvailableOption);
    }

    // esc key pressed
    if (event.keyCode === 27) {
      toggleSelector();
    }
  };
  var isSelected = function isSelected(option) {
    return selectedOptionId === option.id;
  };
  var getSelectedOptionId = function getSelectedOptionId() {
    if (form && field) return form.values()[field];
    if (selectedValue) return selectedValue;
    if (defaultValue) return defaultValue;
    return null;
  };
  var checkIfAtBottom = function checkIfAtBottom(e) {
    var _e$target, _e$target2, _e$target3;
    var onGetToBottom = props.onGetToBottom;
    if (options.length && !filteredOptions.length) {
      onGetToBottom();
    }
    if (!selectorOpened || !onGetToBottom) return;
    var bottom = ((_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.scrollHeight) - ((_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : _e$target2.scrollTop) === ((_e$target3 = e.target) === null || _e$target3 === void 0 ? void 0 : _e$target3.clientHeight);
    if (bottom) {
      onGetToBottom();
    }
  };
  var getFilteredOptions = function getFilteredOptions() {
    var onSearch = props.onSearch; // if custom onSearch function is provided, use it to filter options - return default options
    if (userInput && !onSearch) {
      return options.filter(function (option) {
        return option.name.toLowerCase().includes(userInput.toLowerCase());
      });
    }
    return options;
  };
  var selectedOptionId = getSelectedOptionId();
  var selectedOption = (options === null || options === void 0 ? void 0 : options.find(function (option) {
    return option.id === selectedOptionId;
  })) || null;
  var filteredOptions = getFilteredOptions();
  var renderOptions = function renderOptions() {
    if (!loading && !filteredOptions.length) {
      return /*#__PURE__*/_react["default"].createElement(_styles.OptionsWrapper, {
        style: style === null || style === void 0 ? void 0 : style.OptionsWrapper
      }, /*#__PURE__*/_react["default"].createElement(_styles.Option, {
        disabled: true
      }, notFoundContent || formatMessage(_messages["default"].nothingToSelect)));
    }
    return /*#__PURE__*/_react["default"].createElement(_styles.OptionsWrapper, {
      role: "combobox",
      style: style === null || style === void 0 ? void 0 : style.OptionsWrapper,
      onScroll: checkIfAtBottom,
      ref: wrapperRef
    }, filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.map(function (option) {
      return /*#__PURE__*/_react["default"].createElement(_styles.Option, {
        key: option.id,
        onClick: function onClick() {
          return !option.disabled && onChange(option.id);
        },
        selected: isSelected(option),
        role: "option",
        "aria-selected": isSelected(option),
        disabled: option.disabled,
        style: option.style,
        hidden: option.hidden
      }, option.iconId && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        iconId: option.iconId
      }), option.name, isSelected(option) && /*#__PURE__*/_react["default"].createElement(_styles.CheckMark, null));
    }), loading && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_styles.SkeletonOption, null, /*#__PURE__*/_react["default"].createElement(_styles.SkeletonDiv, {
      width: "200px"
    })), /*#__PURE__*/_react["default"].createElement(_styles.SkeletonOption, null, /*#__PURE__*/_react["default"].createElement(_styles.SkeletonDiv, {
      width: "200px"
    })), /*#__PURE__*/_react["default"].createElement(_styles.SkeletonOption, null, /*#__PURE__*/_react["default"].createElement(_styles.SkeletonDiv, {
      width: "200px"
    }))));
  };
  return /*#__PURE__*/_react["default"].createElement(_styles.SelectWrapper, {
    id: "select-wrapper-".concat(inputId),
    style: style,
    display: display,
    role: "listbox",
    disabled: disabled
  }, label && /*#__PURE__*/_react["default"].createElement(_styles.Label, {
    htmlFor: inputId
  }, label), /*#__PURE__*/_react["default"].createElement(_Dropdown["default"], {
    open: selectorOpened,
    visible: selectorOpened,
    toggle: toggleSelector,
    onVisibleChange: toggleSelector,
    overlayClassName: "c-header__popover__inner",
    placement: "bottomRight",
    trigger: "click",
    content: renderOptions(),
    getPopupContainer: function getPopupContainer() {
      return document.getElementById("select-wrapper-".concat(inputId));
    },
    width: width
  }, /*#__PURE__*/_react["default"].createElement(_styles.Select, {
    disabled: disabled,
    iconId: "sort",
    iconOnRight: true,
    label: (_selectedOption$name = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.name) !== null && _selectedOption$name !== void 0 ? _selectedOption$name : placeholder,
    open: !disabled && selectorOpened,
    showSearch: showSearch,
    style: style === null || style === void 0 ? void 0 : style.Select,
    width: width
  }, /*#__PURE__*/_react["default"].createElement(_styles.UserInput, _extends({
    autoFocus: selectorOpened && showSearch,
    id: inputId,
    style: style === null || style === void 0 ? void 0 : style.Input,
    placeholder: (_selectedOption$name2 = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.name) !== null && _selectedOption$name2 !== void 0 ? _selectedOption$name2 : placeholder,
    readOnly: !showSearch,
    value: selectorOpened ? userInput : (_selectedOption$name3 = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.name) !== null && _selectedOption$name3 !== void 0 ? _selectedOption$name3 : '',
    disabled: disabled,
    onKeyDown: handleInputKeydown,
    autoComplete: "off"
  }, showSearch && {
    onChange: updateUserInput
  })), allowClear && selectedOption && !selectorOpened ? /*#__PURE__*/_react["default"].createElement(_styles.Close, {
    id: "close-button",
    onClick: function onClick() {
      return onChange(null);
    }
  }) : /*#__PURE__*/_react["default"].createElement(_styles.Chevron, {
    opened: selectorOpened
  }))), feedbackText && /*#__PURE__*/_react["default"].createElement(_styles.FeedbackText, null, feedbackText));
};
var _default = exports["default"] = (0, _reactIntl.injectIntl)(SelectComponent);
//# sourceMappingURL=index.js.map